export default "__VITE_ASSET__CclEb0uj__"